// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1033":"9b527e11","2190":"47c22b5e","2229":"923de923","8416":"8eb1e94b","8597":"143cc177"}[chunkId] + ".chunk.css";
};